export class ConfirmationContent
{  
    ConfirmationDialogHeader: string;
    ConfirmationDialogBody: string;    
    ConfirmationDialogFooter: string;
}